import { gql } from "@apollo/client";

const schema = {
  delete: {
    name: "deletePlanService",
    serviceName: "shared",
    query: gql`
      mutation deletePlanService($ids: [String]!) {
        deletePlanService(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
